import {get} from 'lodash';
import {SaltusAny} from '../../utils/SaltusAny';

export type Condition<T> = (values: T) => boolean;

export function hasSpecificAnswer<T>(
  enablingQuestionId: keyof T,
  neededValue: SaltusAny
): Condition<T> {
  return (values?: T) => {
    if (!values) {
      return false;
    }
    return get(values, enablingQuestionId) === neededValue;
  };
}

export function hasAnyAnswer<T>(enablingQuestionId: keyof T): Condition<T> {
  return (values?: T) => {
    if (!values) {
      return false;
    }
    return values[enablingQuestionId] !== undefined;
  };
}

export function hasNoAnswer<T>(enablingQuestionId: keyof T): Condition<T> {
  return (values?: T) => {
    if (!values) {
      return false;
    }
    return values[enablingQuestionId] === undefined;
  };
}

export function and<T>(conditions: Condition<T>[]) {
  if (!conditions || conditions.length === 0) {
    return () => false;
  }
  return (values: T) => conditions.every((c) => c(values));
}

export function or<T>(conditions: Condition<T>[]) {
  if (!conditions || conditions.length === 0) {
    return () => false;
  }
  return (values: T) => conditions.some((c) => c(values));
}

export function hasSpecificAnswerThenSetOtherValue<T>(
  enablingQuestionId: keyof T,
  neededValue: SaltusAny,
  keyToSet: string
): Condition<T> {
  return (values?: T) => {
    if (!values) {
      return false;
    }

    const payload = hasSpecificAnswer<T>(enablingQuestionId, neededValue)(values);
    (values as any)[keyToSet] = payload;

    return payload;
  };
}
